export const smid = ref<string | null>(null)
